import src from "IMAGE";
export default { src, width: 339, height: 75, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAQ0lEQVR42k3KMQ6AMAhA0R7LRNkZvEU3MLGRBLAL4eZtt/71v4KI9zEDgCsiflVtZtaIqLr7VzZwZmYXkWcNZq4TvwPvdxgX6wFh/AAAAABJRU5ErkJggg=="};
